import { GameMode, LobbyRoomResponse, MatchEvent, PoolLeagueId, PoolMinRating, PoolMinRatingOptionsResponse, SessionSnapshotResponse, SpectateStateResponse } from "./contracts";
import { authHeaders, getApiBase, getApiPrefix, parseOrThrow } from "./httpClient";

export async function listLobbies(): Promise<LobbyRoomResponse[]> {
  const response = await fetch(`${getApiBase()}${getApiPrefix()}/lobbies`, {
    headers: authHeaders(),
  });
  return parseOrThrow<LobbyRoomResponse[]>(response, `listLobbies failed: ${response.status}`);
}

export async function getPoolMinRatingOptions(
  poolLeague: PoolLeagueId
): Promise<PoolMinRatingOptionsResponse> {
  const params = new URLSearchParams({ poolLeague });
  const response = await fetch(`${getApiBase()}${getApiPrefix()}/lobbies/pool-options?${params}`, {
    headers: authHeaders(),
  });
  return parseOrThrow<PoolMinRatingOptionsResponse>(
    response,
    `getPoolMinRatingOptions failed: ${response.status}`
  );
}

export async function createRoom(
  nickname: string,
  gameMode: GameMode = "DUEL",
  minPoolRating: PoolMinRating = 70,
  poolLeague: PoolLeagueId = "PREMIER_LEAGUE"
): Promise<SessionSnapshotResponse> {
  const response = await fetch(`${getApiBase()}${getApiPrefix()}/lobbies`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ nickname, gameMode, minPoolRating, poolLeague }),
  });
  return parseOrThrow<SessionSnapshotResponse>(response, `createRoom failed: ${response.status}`);
}

export async function joinRoom(sessionId: string, nickname: string): Promise<SessionSnapshotResponse> {
  const response = await fetch(`${getApiBase()}${getApiPrefix()}/lobbies/${sessionId}/join`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ nickname }),
  });
  return parseOrThrow<SessionSnapshotResponse>(response, `joinRoom failed: ${response.status}`);
}

export async function leaveLobby(sessionId: string): Promise<SessionSnapshotResponse> {
  const response = await fetch(`${getApiBase()}${getApiPrefix()}/sessions/${sessionId}/players/me`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  return parseOrThrow<SessionSnapshotResponse>(response, `leaveLobby failed: ${response.status}`);
}

export async function getSpectateState(sessionId: string): Promise<SpectateStateResponse> {
  const response = await fetch(`${getApiBase()}${getApiPrefix()}/sessions/${sessionId}/spectate`, {
    headers: authHeaders(),
  });
  return parseOrThrow<SpectateStateResponse>(response, `getSpectateState failed: ${response.status}`);
}

export async function getSpectateMatchTimeline(sessionId: string): Promise<MatchEvent[]> {
  const response = await fetch(`${getApiBase()}${getApiPrefix()}/sessions/${sessionId}/spectate/match-timeline`, {
    method: "GET",
  });
  if (response.status === 404) {
    return [];
  }
  return parseOrThrow<MatchEvent[]>(response, `getSpectateMatchTimeline failed: ${response.status}`);
}
